var version = {
    "name":      "dativery",
    "buildDateCode": "20260226-163427",
    "buildDate": "Thu Feb 26 2026 16:34:27 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260226-163427",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;